import React from 'react'; 
import './App.css';
import './styles.scss'
import Routing from './routes/routing';

function App() {
  return (
    <Routing />
  );
}

export default App;
